import { useTranslation } from 'react-i18next';

import './TopLeaders.css';
import type { ChallengeTypeApi } from '../../types/api/challenges';
import type { ChallengeLeaderEntryRedux } from '../../types/models/challenges';

import { Button } from '../../shared/components/button/Button';
import SingleLeader from './SingleLeader';

interface TopLeadersProps {
  dataToMap: ChallengeLeaderEntryRedux[] | number[];
  challengeType: ChallengeTypeApi | string;
  leadersNumber: number;
  buttonText: string;
  isActive: boolean | null;
  handleButtonClick: () => void;
}

function TopLeaders({
  dataToMap,
  challengeType,
  leadersNumber,
  buttonText,
  isActive,
  handleButtonClick,
}: TopLeadersProps) {
  const { t } = useTranslation();
  return (
    <div className="leaders">
      <ul className="leaders-heads" aria-label={t('challenge.leaderboard.title')}>
        {dataToMap.map((leader, index) => (
          <SingleLeader
            key={typeof leader === 'object' ? `leader-${leader.place}` : `placeholder-${leader}`}
            leader={leader}
            index={index}
            leadersNumber={leadersNumber}
            challengeType={challengeType}
          />
        ))}
      </ul>
      {isActive && (
        <Button className="feature-btn topLeaders" onClick={handleButtonClick}>
          {buttonText}
        </Button>
      )}
    </div>
  );
}

export default TopLeaders;
